import React, { useState, useMemo, useContext, useEffect } from "react";
import { Row, Col, Button, OverlayTrigger, Popover } from "react-bootstrap";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { DesignContext } from "contexts/DesignContext";
import { themeDefault } from "../../themes/containerTheme";
import objectPath from "object-path";
import TaskAlt from "@mui/icons-material/TaskAlt";
import {
  checkHasShow,
  checkIsShow,
} from "designer/component/action/condition/Action";
import useAuth from "hooks/useAuth";
import { getShowUiConfig } from "designer/component/action/Config";
import { getDesignerDragItemProps } from "./customDragDrop";

const DragWrapper = (props) => {
  let { uischema, path, children, noPadding = false } = props;

  const designContext = useContext(DesignContext);
  const {
    current,
    deleteUi,
    closeUi,
    newUi,
    setNewUi,
    tempUi,
    setTempUi,
    jsonForm,
    elementAction,
    showBindData,
    showBindParam,
  } = designContext;

  const { config } = useAuth();
  const isShowUiConfig = getShowUiConfig({ uischema, config, jsonForm });
  let hasShow = checkHasShow({ designContext, uischema, config: props.config });
  let isShow = checkIsShow({ designContext, uischema, config: props.config });
  const dragItemProps = getDesignerDragItemProps({
    designContext,
    uischema,
    config: props.config,
  });

  const [isRender, setIsRender] = useState(false);

  const updateCreate = (key) => {
    if ([path, uischema.key, uischema.name].includes(key)) {
      setNewUi(null);
      setTempUi([]);
    } else {
      setTempUi([...tempUi, path]);
    }
  };

  const updateMove = (source, destination) => {
    if (destination) {
      setNewUi({
        rerender: true,
        move: true,
        key: destination,
        source: source,
      });
    } else if (source) {
      setNewUi({
        move: true,
        key: source,
      });
    }
  };

  useEffect(() => {
    if (!newUi) return;
    if (newUi.rerender) return setIsRender(true);
    if (tempUi.some((value) => value === path)) return;
    let mapNewUi = objectPath.get(jsonForm, `schema.mapName.${newUi.key}`);
    let mapNewUiKey = objectPath.get(jsonForm, `schema.mapKey.${newUi.key}`);
    let currentPath = [path, uischema.key, uischema.name].filter(Boolean);
    let mapName = mapNewUi?.split(".") || [];
    let mapKey = mapNewUiKey?.split(".") || [];
    let mapPath = [...mapName, ...mapKey];
    if (mapPath.length > 0) {
      if (mapPath.some((value) => currentPath.includes(value))) {
        setIsRender(true);
      }
    }
  }, [children, newUi]);

  useEffect(() => {
    if (isRender && newUi) {
      setIsRender(false);
      if (newUi.create) {
        let { key } = newUi;
        updateCreate(key);
      } else if (newUi.move) {
        let { source, destination } = newUi;
        updateMove(source, destination);
      }
    }
  }, [isRender]);

  const mapBind =
    objectPath.get(jsonForm, `schema.mapBind.${uischema.key}`) || [];
  const bindData = mapBind && mapBind.filter(({ data = "" }) => data);
  const bindPathParam =
    mapBind && mapBind.filter(({ pathParam = "" }) => pathParam);
  const bindQueryParam =
    mapBind && mapBind.filter(({ queryParam = "" }) => queryParam);

  const PopOverData = (
    <Popover>
      <Popover.Title as="h3">ชื่อ API : ชื่อ Data</Popover.Title>
      <Popover.Content>
        <Row>
          {bindData &&
            bindData.map(({ apiName, data, key }, index) => (
              <Col sm="12" key={`bind-${key}`}>
                {index + 1}. {apiName} : {data}
              </Col>
            ))}
        </Row>
      </Popover.Content>
    </Popover>
  );

  const PopOverPathParam = (
    <Popover>
      <Popover.Title as="h3">ชื่อ API : ชื่อ Path Param </Popover.Title>
      <Popover.Content>
        <Row>
          {bindPathParam &&
            bindPathParam.map(({ apiName, pathParam, key }, index) => (
              <Col sm="12" key={`bind-${key}`}>
                {index + 1}. {apiName} : {pathParam}
              </Col>
            ))}
        </Row>
      </Popover.Content>
    </Popover>
  );

  const PopOverQueryParam = (
    <Popover>
      <Popover.Title as="h3">ชื่อ API : ชื่อ Query Param </Popover.Title>
      <Popover.Content>
        <Row>
          {bindQueryParam &&
            bindQueryParam.map(({ apiName, queryParam, key }, index) => (
              <Col sm="12" key={`bind-${key}`}>
                {index + 1}. {apiName} : {queryParam}
              </Col>
            ))}
        </Row>
      </Popover.Content>
    </Popover>
  );

  const [showPopOverData, setShowPopOverData] = useState(false);
  const [showPopOverPathParam, setShowPopOverPathParam] = useState(false);
  const [showPopOverQueryParam, setShowPopOverQueryParam] = useState(false);

  useEffect(() => {
    if (!showBindData) {
      setShowPopOverData(false);
    }
  }, [showBindData]);

  useEffect(() => {
    if (!showBindParam) {
      setShowPopOverPathParam(false);
      setShowPopOverQueryParam(false);
    }
  }, [showBindParam]);

  return (
    <Col
      className="p-0"
      sm={uischema.layoutWidth}
      hidden={hasShow ? !isShow : !isShowUiConfig}
      {...dragItemProps}
    >
      <div>
        <div
          style={{ border: "1px dashed" }}
          className={`${noPadding ? "p-0" : "p-1"} m-1 rounded ${
            current.ui.key === uischema.key
              ? "border-warning"
              : "border-secondary"
          }`}
        >
          <Row className="w-100 mx-0 mb-1 d-flex justify-content-end">
            <Col sm="12" lg="auto" className="p-0">
              {bindPathParam.length > 0 && (
                <OverlayTrigger
                  show={showPopOverPathParam || showBindParam}
                  trigger="click"
                  placement="top"
                  overlay={PopOverPathParam}
                >
                  <Button
                    variant="muted"
                    className="pu-0 px-1"
                    onClick={() =>
                      setShowPopOverPathParam(!showPopOverPathParam)
                    }
                  >
                    <TaskAlt color="success" /> Path Param
                  </Button>
                </OverlayTrigger>
              )}
              {bindQueryParam.length > 0 && (
                <OverlayTrigger
                  show={showPopOverQueryParam || showBindParam}
                  trigger="click"
                  placement="top"
                  overlay={PopOverQueryParam}
                >
                  <Button
                    variant="muted"
                    className="pu-0 px-1"
                    onClick={() =>
                      setShowPopOverQueryParam(!showPopOverQueryParam)
                    }
                  >
                    <TaskAlt color="success" /> Query Param
                  </Button>
                </OverlayTrigger>
              )}
              {bindData.length > 0 && (
                <OverlayTrigger
                  show={showPopOverData || showBindData}
                  trigger="click"
                  placement="top"
                  overlay={PopOverData}
                >
                  <Button
                    variant="muted"
                    className="pu-0 px-1"
                    onClick={() => setShowPopOverData(!showPopOverData)}
                  >
                    <TaskAlt color="success" /> Data
                  </Button>
                </OverlayTrigger>
              )}
              <Button
                variant={"secondary"}
                className="btn-icon py-0 px-1 ml-1 mr-0"
                onClick={() => closeUi(uischema.key)}
              >
                <i className="feather icon-minus"></i>
              </Button>
              <Button
                variant={"danger"}
                className="btn-icon py-0 px-1 ml-1 mr-0"
                onClick={() => {
                  setNewUi({ delete: true, key: uischema.key });
                  deleteUi(uischema, path, uischema.key);
                }}
                hidden={!uischema.isCanDelete}
              >
                <i className="feather icon-trash"></i>
              </Button>
            </Col>
          </Row>
          <div className="w-100">
            <MuiThemeProvider theme={themeDefault}>
              <div
              // style={{
              //   padding: uischema.layoutPadding ?? '',
              //   margin: uischema.layoutMargin ?? '',
              // }}
              >
                {children}
              </div>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default DragWrapper;
